import React, { useState, useEffect } from 'react';


const WelcomePage = () => {
    
    return (
        <div className="min-h-[70vh] flex justify-center items-center bg-gradient-to-br from-blue-500 to-indigo-600 p-4">
          <div className="bg-white/20 backdrop-blur-lg border border-white/30 shadow-xl rounded-2xl p-8 text-center max-w-md">
            <h1 className="text-white text-3xl font-extrabold tracking-wide">
              Hi {localStorage.getItem("userNAME")} 👋
            </h1>
            <p className="text-white/90 text-lg mt-2">
              Welcome to <span className="text-yellow-300 font-bold">Quick Verification</span>
            </p>
          </div>
        </div>
      );
};

export default WelcomePage;
